import * as React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { ListLink } from "../../themeV2";

/**
 * @deprecated Use `ListLink` from themeV2 directly.
 */
const StreamilyListLink = React.forwardRef(function StreamilyListLink(
  { to, onClick, exact, startIcon, label, endIcon, className, href },
  ref,
) {
  const Component = to ? NavLink : href ? "a" : "button";
  const routerProps = to
    ? { to, exact, activeClassName: ListLink.activeClassName }
    : {};
  const linkProps = href ? { href } : {};

  return (
    <ListLink
      ref={ref}
      as={Component}
      leading={startIcon}
      trailing={endIcon}
      onClick={onClick}
      className={className}
      {...routerProps}
      {...linkProps}
    >
      {label}
    </ListLink>
  );
});

StreamilyListLink.displayName = "StreamilyListLink";

StreamilyListLink.propTypes = {
  to: PropTypes.string,
  exact: PropTypes.bool,
  onClick: PropTypes.func,
  startIcon: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  endIcon: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
};

export default StreamilyListLink;
